import { Link } from 'react-router-dom';
import React, { useEffect, useRef, useCallback } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CountUp } from 'countup.js';

gsap.registerPlugin(ScrollTrigger);
const WhyChooseUs = () => {
    const revealRefs = useRef([]);

    const addRevealRef = useCallback((el) => {
        if (el && !revealRefs.current.includes(el)) {
            revealRefs.current.push(el);
        }
    }, []);
    useEffect(() => {
            // GSAP Reveal Animation
            revealRefs.current.forEach((container) => {
                const image = container.querySelector('img');
    
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        toggleActions: 'play none none none',
                    },
                });
    
                tl.set(container, { autoAlpha: 1 });
    
                tl.from(container, {
                    // xPercent: -100,
                    duration: 1,
                    ease: 'power2.out',
                });
    
                tl.from(image, {
                    xPercent: 100,
                    scale: 1,
                    delay: -1,
                    duration: 1,
                    ease: 'power2.out',
                });
            });
        }, []);
    return (
        <>
            {/* Why Choose Us Section Start */}
            <div className="why-choose-us">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">why choose us</h3>
                                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                                        A behind the scenes look at <span>our agency</span>
                                    </h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                                        From concept to completion, discover how we bring your vision to
                                        life with innovation, collaboration, and expert craftsmanship.
                                    </p>
                                </div>
                                {/* Section Title End */}
                                {/* Why Choose Item List Start */}
                                <div className="why-choose-item-list">
                                    {/* Why Choose Item Start */}
                                    <div
                                        className="why-choose-item wow fadeInUp"
                                        data-wow-delay="0.4s"
                                    >
                                        {/* Icon Box Start */}
                                        <div className="icon-box">
                                            <img src="images/icon-why-choose-1.svg" alt="" />
                                        </div>
                                        {/* Icon Box End */}
                                        {/* Why Choose Item Content Start */}
                                        <div className="why-choose-item-content">
                                            <h3>tailored design solutions</h3>
                                            <p>
                                                We provide personalized interior design services that
                                                reflect your unique vision and lifestyle.
                                            </p>
                                        </div>
                                        {/* Why Choose Item Content End */}
                                    </div>
                                    {/* Why Choose Item End */}
                                    {/* Why Choose Item Start */}
                                    <div
                                        className="why-choose-item wow fadeInUp"
                                        data-wow-delay="0.6s"
                                    >
                                        {/* Icon Box Start */}
                                        <div className="icon-box">
                                            <img src="images/icon-why-choose-2.svg" alt="" />
                                        </div>
                                        {/* Icon Box End */}
                                        {/* Why Choose Item Content Start */}
                                        <div className="why-choose-item-content">
                                            <h3>Seamless Project Management</h3>
                                            <p>
                                                We handle the entire design process, from concept to
                                                completion, with flawless execution.
                                            </p>
                                        </div>
                                        {/* Why Choose Item Content End */}
                                    </div>
                                    {/* Why Choose Item End */}
                                    {/* Why Choose Item Start */}
                                    <div
                                        className="why-choose-item wow fadeInUp"
                                        data-wow-delay="0.8s"
                                    >
                                        {/* Icon Box Start */}
                                        <div className="icon-box">
                                            <img src="images/icon-why-choose-3.svg" alt="" />
                                        </div>
                                        {/* Icon Box End */}
                                        {/* Why Choose Item Content Start */}
                                        <div className="why-choose-item-content">
                                            <h3>Client-Centered Collaboration</h3>
                                            <p>
                                                Your input is valued throughout the entire process, ensuring
                                                your vision is fully realized.
                                            </p>
                                        </div>
                                        {/* Why Choose Item Content End */}
                                    </div>
                                    {/* Why Choose Item End */}
                                </div>
                                {/* Why Choose Item List End */}
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        <div className="col-lg-7">
                            {/* Why Choose Images Images Start */}
                            <div className="why-choose-images">
                                {/* Why Choose Box 1 Start */}
                                <div className="why-choose-img-box-1">
                                    {/* Why Choose img 1 Start */}
                                    <div className="why-choose-img-1">
                                        <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                                            <img src="images/why-choose-img-1.jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Why Choose img 1 End */}
                                    {/* Why Choose img 2 Start */}
                                    <div className="why-choose-img-2">
                                        <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                                            <img src="images/why-choose-img-2.jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Why Choose img 2 End */}
                                </div>
                                {/* Why Choose Box 1 End */}
                                {/* Why Choose Box 2 Start */}
                                <div className="why-choose-img-box-2">
                                    {/* Why Choose img 3 Start */}
                                    <div className="why-choose-img-3">
                                        <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                                            <img src="images/why-choose-img-3.jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Why Choose img 3 End */}
                                    {/* Why Choose img 4 Start */}
                                    <div className="why-choose-img-4">
                                        <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                                            <img src="images/why-choose-img-4.jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Why Choose img 4 End */}
                                </div>
                                {/* Why Choose Box 2 End */}
                            </div>
                            {/* Why Choose Images Images End */}
                        </div>
                    </div>
                </div>
            </div>
            {/* Why Choose Us Section End */}
        </>
    )
}

export default WhyChooseUs
